<!--
 * @Description: 编辑优惠活动
 * @Author: 琢磨先生
 * @Date: 2023-08-23 12:53:12
 * @LastEditors: cts 308360781@qq.com
 * @LastEditTime: 2025-01-08 09:57:27
-->
<template>
  <el-drawer
    :title="`${form?.type_text}`"
    v-model="visibleDrawer"
    direction="rtl"
    size="1000px"
    :destroy-on-close="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @closed="onClose"
  >
    <el-scrollbar v-loading="loading">
      <div
        style="
          white-space: pre-line;
          color: #909399;
          font-size: 14px;
          margin-bottom: 20px;
        "
      >
        {{ form?.description }}
      </div>
      <el-timeline>
        <el-timeline-item>
          <p>1、设置优惠</p>
          <el-form
            label-position="top"
            :model="form"
            ref="form"
            class="act-form"
            :rules="rules"
            label-width="100px"
          >
            <el-form-item label="入住日期范围">
              <el-row>
                <el-date-picker
                  :disabled="!form.is_allow"
                  value-format="YYYY-MM-DD"
                  :disabled-date="disabledDate"
                  v-model="form.start_date"
                  placeholder="开始日期"
                ></el-date-picker>
                <span>-</span>
                <el-date-picker
                  :disabled="!form.is_allow"
                  value-format="YYYY-MM-DD"
                  :disabled-date="disabledDate"
                  v-model="form.end_date"
                  placeholder="结束日期"
                ></el-date-picker>
              </el-row>
              <div class="help-block" v-if="!form.is_allow">
                该入住日期范围由平台设定
              </div>
            </el-form-item>
            <el-form-item
              label="自动延期"
              v-if="form.is_allow && form.lengthen_days > 0"
            >
              <el-switch v-model="form.is_auto_lengthen"></el-switch>
              <div class="help-block">
                活动到期后自动延长{{ form.lengthen_days }}天
              </div>
            </el-form-item>

            <el-form-item label="优惠设置">
              <el-alert
                :closable="false"
                title="抵扣积分"
                type="info"
                v-if="form.type == 1"
              >
                <el-tag
                  v-for="x in form.items"
                  :closable="false"
                  :key="x"
                  style="margin-right: 10px; margin-bottom: 10px"
                >
                  <span>{{ x.score }}积分</span>
                </el-tag>
              </el-alert>
              <el-alert
                type="info"
                :closable="false"
                title
                v-if="!form.is_general"
              >
                <el-row :gutter="20" v-for="(item, i) in items" :key="i">
                  <el-col
                    :span="9"
                    v-if="[0, 2, 3, 4].findIndex((o) => o === form.type) > -1"
                  >
                    <el-row>
                      <el-col :span="8">
                        <div class="item_name">梯度{{ i + 1 }}</div>
                      </el-col>
                      <el-col :span="15">
                        <div v-if="form.type == 0">会员等级</div>
                        <div v-if="form.type == 2">提前天数</div>
                        <div v-if="form.type == 3">最少连住天数</div>
                        <div v-if="form.type == 4">几点开始</div>
                        <el-select
                          v-model="item.level"
                          placeholder
                          v-if="form.type == 0"
                        >
                          <el-option
                            :label="x.name"
                            :value="x.level"
                            v-for="x in gradeList"
                            :key="x.id"
                          ></el-option>
                        </el-select>
                        <el-select
                          v-model="item.days"
                          placeholder
                          v-if="form.type == 2 || form.type == 3"
                        >
                          <el-option
                            :label="`${d}天`"
                            :value="d"
                            v-for="d in 30"
                            :key="d"
                          ></el-option>
                        </el-select>

                        <el-row v-if="form.type == 4">
                          <el-col :span="24">
                            <el-select v-model="item.start_hour" placeholder>
                              <el-option
                                :label="`${d - 1}:00`"
                                :value="d - 1"
                                v-for="d in 24"
                                :key="d"
                              ></el-option>
                            </el-select>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                  </el-col>

                  <el-col :span="6" v-if="form.type != 1">
                    <el-row>
                      <el-col :span="4" v-if="form.way == 2">
                        <div>优惠方式</div>
                        <el-select v-model="item.way" placeholder>
                          <el-option label="折扣" :value="0"></el-option>
                          <el-option label="立减" :value="1"></el-option>
                        </el-select>
                      </el-col>
                      <el-col :span="20" :offset="0" v-if="item.way == 0">
                        <span>售卖折扣</span>
                        <el-input
                          v-model="item.decimal_discount"
                          placeholder
                        ></el-input>
                        <div class="help-block">
                          折扣范围{{ form.value_min }}~{{ form.value_max }}
                        </div>
                      </el-col>
                      <el-col :span="20" :offset="0" v-if="item.way == 1">
                        <span>立减</span>
                        <el-input
                          v-model="item.decimal_amount"
                          placeholder
                        ></el-input>
                        <div class="help-block">下单立减金额</div>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="6" :offset="0" v-if="form.type == 1">
                    <span>抵扣积分</span>
                    <el-input v-model="item.score" placeholder></el-input>
                    <div class="help-block">
                      最大抵扣积分不超过{{ form.score_max }}
                    </div>
                  </el-col>
                  <el-col :span="1" class="col-del" v-if="i > 0">
                    <el-button
                      type="danger"
                      link
                      class="text-danger"
                      size="small"
                      @click="items.splice(i, 1)"
                      >删除</el-button
                    >
                  </el-col>
                </el-row>
                <div class="flex-row item-center">
                  <el-button
                    size="small"
                    round
                    @click="addItem"
                    v-if="form.stairway_num > 1"
                    icon="plus"
                    >添加梯度</el-button
                  >
                  <span style="margin-left: 20px"
                    >最多可添加{{ form.stairway_num }}个梯度</span
                  >
                </div>
              </el-alert>
            </el-form-item>
          </el-form>
        </el-timeline-item>
        <el-timeline-item>
          <p>2、选择房源</p> 
          <el-form-item label="全部房源" >
            <el-switch v-model="form.is_all"></el-switch>
          </el-form-item>
          <house-choose
            :ids="house_ids" :all="true"
            @change="houseChooseChange"
          ></house-choose>
        </el-timeline-item>
      </el-timeline>
    </el-scrollbar>

    <template #footer v-if="!form.is_general">
      <el-button type="primary" :loading="saving" @click="onSubmit"
        >确定</el-button
      >
    </template>
  </el-drawer>
</template>

<script>
import common_api from "@/http/common_api";
import HouseChoose from "@/views/components/house_choose.vue";
export default {
  components: {
    HouseChoose,
  },
  data() {
    return {
      visibleDrawer: false,
      loading: false,
      saving: false,
      form: {},
      rules: {},
      selectionList: [],
      //
      house_ids: [],
      items: [],
      gradeList: [],
    };
  },
  emits: ["success", "close"],
  props: ["type"],
  watch: {
    type: {
      handler() {
        if (typeof this.type == "number" && this.type >= 0) {
          this.form = {};
          this.visibleDrawer = true;
          this.loadDtl();
        }
      },
      immediate: true,
    },
  },
  created() {
    this.loadGrade();
  },
  methods: {
    loadGrade() {
      common_api.get_grade().then((res) => {
        if (res.code == 0) {
          this.gradeList = res.data;
        }
      });
    },

    /**
     * 加载详情
     */
    loadDtl() {
      this.loading = true;
      this.$http
        .get("/seller/v1/activity/join/dtl?type=" + this.type)
        .then((res) => {
          if (res.code == 0) {
            var model = res.data;
            this.form = Object.assign({}, model.activity);
            this.form.start_date = model.start_date;
            this.form.end_date = model.end_date;
            this.items = model.items;
            this.form.is_all = model.is_all;
            this.house_ids = model.houses.map((o) => o.id);
          }
          this.loading = false;
        });
    },
    /**
     * 禁用选择的时间
     */
    disabledDate(date) {
      var now = new Date();
      now.setDate(now.getDate() - 1);
      if (date < now) return true;
      now.setFullYear(now.getFullYear() + 1);
      if (date > now) return true;
    },

    /**
     * 选择楼盘更改
     * @param {*} list
     */
    houseChooseChange(list) {
      this.selectionList = list;
    },

    /**
     * 添加梯度
     */
    addItem() {
      if (this.items.length < this.form.stairway_num) {
        this.items.push({
          days: 1,
          way: 0,
          decimal_discount: "4",
          decimal_amount: "0",
          start_hour: 8,
          end_hour: 22,
        });
      }
    },

    /**
     *
     */
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.saving = true;
          this.form.items = this.items;
          this.form.houses = this.selectionList.map((x) => {
            return { id: x.id };
          });
          this.$http
            .post("seller/v1/activity/join", this.form)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success("保存成功");
                this.visibleDrawer = false;
                this.$emit("success");
              }
            })
            .finally(() => {
              this.saving = false;
            });
        }
      });
    },

    /**
     *
     */
    onClose() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.col-del {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
</style>
